import React, { Component } from 'react';
import WhiteLayout from '../../template/WhiteLayout';
import Form, { SimpleItem, GroupItem } from 'devextreme-react/form';
import API from '../../services/AplicationService';
import { Link } from 'react-router-dom';
import { showSuccessMessage, showConfirmationMessage, handleError } from '../../utils/Utility';
import * as messages from '../../utils/Messages';

const initialState = {
	disabled: true,
	changeCreatePassword: {
		email: '',
		token: '',
		password: '',
		confirmPassword: '',
	},
};
export default class CreateChangePassword extends Component {
	state = { ...initialState };
	changeCreatePassword = {
		email: '',
		token: '',
		password: '',
		confirmPassword: '',
	};
	constructor(props) {
		super(props);
		this.onClickConfirm = this.onClickConfirm.bind(this);
		this.setStateDataToInitial = this.setStateDataToInitial.bind(this);
		this.changePassword = this.changePassword.bind(this);
		this.form = React.createRef();
		this.getOperation = this.getOperation.bind(this);
	}

	changePassword() {
		const { history } = this.props;
		this.setState({
			...this.state,
			disabled: true,
		});
		let path = window.location.pathname
			.toString()
			.trim()
			.toLowerCase();
		let changeCreatePassword = { ...this.changeCreatePassword };
		changeCreatePassword.token = this.props.match.params.token;
		API.post('account/changePassword', changeCreatePassword)
			.then(response => {
				if (path.includes('criar')) {
					if (history) history.push('/login');
					showSuccessMessage('Senha criado com sucesso.');
				} else {
					if (history) history.push('/login');
					showSuccessMessage('Senha alterada com sucesso.');
				}
				this.setState({
					...this.state,
					disabled: false,
				});
			})
			.catch(error => {
				this.setState({
					...this.state,
					disabled: false,
				});
				handleError(error, 'Ocorreu uma falha ao tentar criar ou alterar a senha.');
			});
	}

	setStateDataToInitial() {
		this.changeCreatePassword = { ...initialState.changeCreatePassword };
		this.setState({ ...this.state, changeCreatePassword: this.changeCreatePassword });
	}

	onClickConfirm = function() {
		this.changePassword();
	};
	renderMessage() {
		let path = window.location.pathname
			.toString()
			.trim()
			.toLowerCase();
		if (path.includes('criar')) {
			return (
				<p className="general-box-msg">
					Seja bem Vindo! <br /> Crie agora sua senha.
				</p>
			);
		} else {
			return <p className="general-box-msg">Altere sua senha!</p>;
		}
	}
	componentDidMount() {
		let token = this.props.match.params.token;
		const { history } = this.props;
		if (token !== '') {
			API.get('account/validTokenCreateOrChangePassword?token=' + token)
				.then(response => {
					let user = { ...response.data };
					this.changeCreatePassword.email = user.email;
					this.setState({
						...this.state,
						disabled: false,
						changeCreatePassword: this.changeCreatePassword,
					});
				})
				.catch(error => {
					handleError(error, messages.errorGetData);
					if (history) history.push('/login');
				});
		}
	}
	getOperation() {
		let path = window.location.pathname
			.toString()
			.trim()
			.toLowerCase();
		if (!path.includes('criar')) {
			return 'alterar a senha';
		} else {
			return 'cirar a senha';
		}
	}
	render(props) {
		let captionMessage = (
			<React.Fragment>
				<h3 className="text-center">Seja bem Vindo!</h3>
				<p className="general-box-msg">
					Esse é seu primeiro acesso.
					<br /> Cadastre uma senha com no mínimo 6 digitos.
				</p>
			</React.Fragment>
		);
		let path = window.location.pathname
			.toString()
			.trim()
			.toLowerCase();
		if (!path.includes('criar')) {
			captionMessage = (
				<React.Fragment>
					<h3 className="text-center">Altere a sua Senha!</h3>
					<p className="general-box-msg">
						Digite a nova senha desejada e confirme. A senha deve ter no mínimo 6 digios.
					</p>
				</React.Fragment>
			);
		}
		return (
			<React.Fragment>
				<WhiteLayout>
					<div className="general-box">
						<div className="general-box-header">
							<img
								src={require('../../resources/images/logo.png')}
								style={{ width: '100%', height: 'auto' }}
								// className="img-fluid"
								alt="SENC App"
							/>
						</div>
						<div className="general-box-body">
							{captionMessage}
							<Form
								formData={this.changeCreatePassword}
								ref={this.form}
								showColonAfterLabel={false}
								labelLocation={'top'}
							>
								<SimpleItem
									dataField={'email'}
									label={{ text: 'E-mail' }}
									editorOptions={{ disabled: true }}
								/>
								<SimpleItem
									dataField={'password'}
									label={{ text: 'Senha' }}
									editorOptions={{
										mode: 'password',
										placeholder: 'digite aqui a senha desejada',
										disabled: this.state.disabled,
									}}
								/>
								<SimpleItem
									dataField={'confirmPassword'}
									label={{ text: 'Confirmar Senha' }}
									editorOptions={{
										mode: 'password',
										placeholder: 'confirme aqui a senha desejada',
										disabled: this.state.disabled,
									}}
								/>
								<GroupItem>
									<div className="pull-left">
										<Link to="/login">desistiu de {this.getOperation()}?</Link>
									</div>
									<div className="pull-right">
										<button
											type="button"
											className="btn btn-success"
											disabled={this.state.disabled}
											onClick={this.onClickConfirm}
										>
											<i className="fa fa-check" />
											&nbsp; Confirmar
										</button>
									</div>
								</GroupItem>
							</Form>
						</div>
					</div>
				</WhiteLayout>
			</React.Fragment>
		);
	}
}
